import * as LucideIcons from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import { DEFAULT_ICON } from '../model/constants';

export type ResolveIcon = (iconName: string) => LucideIcon;

/**
 * Resolves icon name string to Lucide icon component
 * Returns default icon if specified icon doesn't exist
 */
export const resolveIcon: ResolveIcon = (iconName) => {
  const icon = LucideIcons[iconName as keyof typeof LucideIcons] as LucideIcon | undefined;

  if (!icon || typeof icon !== 'function') {
    console.warn(`Icon "${iconName}" not found, using default icon`);
    return LucideIcons[DEFAULT_ICON as keyof typeof LucideIcons] as LucideIcon;
  }

  return icon;
};
